import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1 h-7 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading flex items-center gap-2">
            {icon && (
              <span className="w-6 h-6 flex items-center justify-center">
                <i className={`${icon} text-primary-400`}></i>
              </span>
            )}
            {title}
          </h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}